export default "__VITE_ASSET__DRvjbqDT__"